import { createShowtimeFilter, getShowtimesForEvent } from '@vista/omnichannel-components-domain';
export const setupFilter = (eventId, siteId, filterConfig) => {
    if (!filterConfig)
        return;
    const { filterId, options } = filterConfig;
    const showtimes = getShowtimesForEvent(eventId, siteId);
    createShowtimeFilter(filterId, showtimes, options);
};
